/**
 * This file required data(){return {selectedBankId}}
 */
import { mapGetters } from 'vuex'
import amountDecimalRule from './amount-decimal-rule'

export default {
    mixins: [amountDecimalRule],
    computed: {
        ...mapGetters({
            getMinMaxDepositByCurrency: 'finance/getMinMaxDepositByCurrency',
            bankAccount: 'themes/player-bank/bankAccount',
        }),
        selectedBankCurrency() {
            const selectedBankAccount =
                this.bankAccount.player_bank_accounts?.find(
                    (el) => el.id === this.selectedBankId
                )
            if (!selectedBankAccount) return null
            return selectedBankAccount.currency
        },
        depositAmountRules() {
            return [
                (v) => !!v || `${this.tl('amount')} ${this.tl('isRequired')}`,
            ]
        },
        depositAmountRulesMessage() {
            // Since v-text-field rules is re-checking the validation value, then I need this error-messages instead of rule
            if (!this.form.amount) return null

            const amount = parseFloat(
                this.form.amount?.toString()?.replaceAll(',', '')
            )
            if (amount <= 0) {
                return `${this.tl('amount')} ${this.tl('greaterThanZero')}`
            }
            if (
                amount <
                this.getMinMaxDepositByCurrency(this.selectedBankCurrency)
                    ?.min_deposit
            ) {
                return `${this.tl('minimumDepositIs')} ${this.formatCurrencyJS(
                    this.getMinMaxDepositByCurrency(this.selectedBankCurrency)
                        .min_deposit
                )}`
            }
            if (
                amount >
                this.getMinMaxDepositByCurrency(this.selectedBankCurrency)
                    ?.max_deposit
            ) {
                return `${this.tl('maximumDepositIs')} ${this.formatCurrencyJS(
                    this.getMinMaxDepositByCurrency(this.selectedBankCurrency)
                        ?.max_deposit
                )}`
            }
            if (!this.decimalRule(amount?.toString())) {
                return this.tl('decimalIsTwoDigit')
            }
        },
    },
}
